module.exports = __webpack_public_path__ + "assets/img/kv-5a1e8317.jpg";